import { useState, useEffect } from 'react';

export const useIsTouchDevice = () => {
    const [isTouch, setIsTouch] = useState(false);

    useEffect(() => {
        setIsTouch(typeof window?.ontouchstart !== 'undefined');
    }, []);

    return isTouch;
};
